// Use the same UTC calendar day as the API so validation agrees across time zones.
export const cycleDateBounds = (now = new Date()) => {
  const tomorrow = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1)
  );
  return {
    min: tomorrow.toISOString().slice(0, 10),
    max: `${now.getUTCFullYear() + 100}-12-31`,
  };
};

export const cycleDueDateError = (value, now = new Date()) => {
  if (!value) return "Please select a due date.";
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value))
    return "Enter a valid date with a four-digit year.";
  const parsed = new Date(`${value}T00:00:00Z`);
  if (
    Number.isNaN(parsed.getTime()) ||
    parsed.toISOString().slice(0, 10) !== value
  )
    return "Enter a valid calendar date.";
  const { min, max } = cycleDateBounds(now);
  if (value < min) return "Due date must be after today.";
  if (value > max)
    return "Due date must be within the next 100 years. Check the year.";
  return "";
};

export const cycleDateError = (value, label) => {
  const name = label || "Date";
  if (!value) return `Please select ${name.toLowerCase()}.`;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value))
    return `Enter a valid ${name.toLowerCase()} with a four-digit year.`;
  const parsed = new Date(`${value}T00:00:00Z`);
  if (
    Number.isNaN(parsed.getTime()) ||
    parsed.toISOString().slice(0, 10) !== value
  )
    return `Enter a valid ${name.toLowerCase()}.`;
  return "";
};

export const cycleStandardIds = (inspectionCycle) =>
  inspectionCycle.standardTypeIds?.length
    ? inspectionCycle.standardTypeIds.map(Number)
    : inspectionCycle.standardTypeId
    ? [Number(inspectionCycle.standardTypeId)]
    : [];
export const cycleStandardNames = (inspectionCycle) =>
  inspectionCycle.standardTypes?.length
    ? inspectionCycle.standardTypes.map((standard) => standard.name).join(", ")
    : inspectionCycle.standardType?.name ||
      inspectionCycle.standardTypeName ||
      "—";

// Inclusive annual period: the day before the next anniversary.
export const annualCycleEndDate = (startDate) => {
  if (cycleDateError(startDate, "Start date")) return "";
  const [year, month, day] = startDate.split("-").map(Number);
  const end = new Date(Date.UTC(year + 1, month - 1, day - 1));
  return end.toISOString().slice(0, 10);
};
